import { type ReactNode } from "react";
import { Navigate, Outlet } from "react-router";
import { PUCK_EXTENSION, useFoodpilotContext } from "src/context/FoodpilotContext";
import type { Slugs } from "src/context/ProtectedContext";

type DynaBlocksProtectionProps = {
    action: Slugs;
    children?: ReactNode;
};

export const DynaBlocksProtection = (props: DynaBlocksProtectionProps) => {
    const { action, children } = props;
    const { canUser } = useFoodpilotContext();

    if (!canUser(action, PUCK_EXTENSION)) {
        return <Navigate to="/settings" replace />;
    }

    return children ?? <Outlet />;
};
